import { render, staticRenderFns } from "./WhyChooseUsSales.vue?vue&type=template&id=606d84e6&scoped=true&"
import script from "./WhyChooseUsSales.vue?vue&type=script&lang=ts&"
export * from "./WhyChooseUsSales.vue?vue&type=script&lang=ts&"
import style0 from "./WhyChooseUsSales.vue?vue&type=style&index=0&id=606d84e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606d84e6",
  null
  
)

export default component.exports